<input title="Form input"
  [id]="formId"
  [hidden]="hidden"
  class="form-control"
  type="file"
  (change)="onFileSelected($event)"
/>
